import { render, staticRenderFns } from "./BitstampExchangeInput.vue?vue&type=template&id=cb6dcf2c&"
import script from "./BitstampExchangeInput.vue?vue&type=script&lang=ts&"
export * from "./BitstampExchangeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports